// src/lib/themeColor.js
// Updates the browser chrome color to match the active zone theme.
// Call setThemeColor('recon') from any page component's useEffect.

const ZONE_COLORS = {
  recon:  '#14181a',   // dark base
  dossier:'#1a1420',   // purple-dark
  armor:  '#1a1810',   // warm-dark
  cipher: '#001408',   // green-dark
}

// High-contrast (sunlight) palette — pale background per zone so the
// browser chrome doesn't fight the page's lighter body when the
// player toggles Sun Mode in Settings.
const ZONE_COLORS_HC = {
  recon:   '#f4f6f0',
  dossier: '#f0e6c8',
  armor:   '#f3eee5',
  cipher:  '#eaf4ec',
}

// Source of truth is <html data-dc-mode>, which is set by:
//   1. main.jsx pre-paint hook (current active user's stored mode)
//   2. AuthContext on SIGNED_IN / SIGNED_OUT
//   3. Profile.jsx on user toggle
// Older versions also fell through to a global 'dc_display_mode' key in
// localStorage; that key was per-browser, not per-user, and was the
// vector for Bug 15 (HC leaking across account switches). It's now
// gone entirely.
const isHighContrast = () =>
  typeof document !== 'undefined' && document.documentElement.dataset.dcMode === 'high-contrast'

export function setThemeColor(zone) {
  const map = isHighContrast() ? ZONE_COLORS_HC : ZONE_COLORS
  const color = map[zone] || map.recon
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', color)
  // Stash the active zone so the global stylesheet can react too — the
  // [data-dc-mode="high-contrast"][data-dc-zone="recon"] selector lights
  // up the sunlight overrides defined in index.css.
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.dcZone = zone || 'recon'
  }
}

export default setThemeColor